<template>
    <div v-if="wallet_id" class="w-full flex flex-column">
        <div class="flex flex-row gap-2">
            <Button v-if="isUserInGroup('admin')" label="Пополнить" @click="openPopup('topup')" size="small" :disabled="loading || !wallet_id" icon="pi pi-arrow-down" iconPos="right" severity="success" class="border-none"/>
            <Button v-if="isUserInGroup('admin')" label="Списать" @click="openPopup('withdraw')" size="small" :disabled="loading || !wallet_id" icon="pi pi-arrow-up" iconPos="right" severity="warn"/>
            <Button v-if="isUserInGroup('admin')" label="Перевод" @click="openPopup('transfer')" size="small" :disabled="loading || !wallet_id" icon="pi pi-arrow-right-arrow-left" iconPos="right" severity="info"/>
        </div>

        <!--ПОПОЛНЕНИЕ-->
        <Dialog header="Пополнить" modal v-if="isUserInGroup('admin')" v-model:visible="displayTopup"
            class="flex flex-column border-none" 
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">
            
            <div class="w-full flex flex-column gap-3">
                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма:</span>
                    <InputGroup>
                        <InputNumber v-model="topupAmount" :min="0.0000000000001" :max="100000000" :maxFractionDigits="16" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                </div>

                <div v-if="hasFinId(wallet_id)" class="w-full flex flex-column gap-2">
                    <div class="flex">
                        <ToggleButton v-model="addToAdeskTopup" class="w-24" onLabel="Добавить в Adesk ✅️️️️️️️" offLabel="Добавить в Adesk"  size="small"/>
                    </div>
                    <div v-if="addToAdeskTopup" class="w-full flex flex-column gap-2">
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Статья:</span>
                            <Select v-model="selectedArticleTopup" :options="articleOptions(1)" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите статью" class="w-full border-2 border-round-lg" />
                        </div>
                        <div class="w-full flex flex-column gap-1">
                        <span class="flex text-600 mb-2 text-sm">Поставщик:</span>
                            <Select v-model="selectedContractorTopup" :options="contractorOptions" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите поставщика" class="w-full border-2 border-round-lg" />
                        </div>
                    </div>
                </div>

                <div class="w-full mb-3">
                    <span class="flex text-600 mb-2 text-sm">Описание:</span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                        :value="topupDescription"
                        @input="topupDescription = $event.target.value"
                        placeholder="Пополнение кошелька админом"
                        style="resize: none !important; font-family: inherit;"
                    />
                </div>
            </div>

            <template #footer>
                <Button label="Пополнить" @click='topup()' :disabled="topupDisabled" :loading="loading"/>
            </template>
        </Dialog>

        <!--СПИСАНИЕ-->
        <Dialog header="Списать" modal v-if="isUserInGroup('admin')" v-model:visible="displayWithdraw"
            class="flex flex-column border-none" 
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">

            <div class="w-full flex flex-column gap-3">
                 <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">Сумма:</span>
                    <InputGroup>
                        <InputNumber v-model="withdrawAmount" :min="0.0000000000001" :max="100000000" :maxFractionDigits="16" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                </div>

                <div v-if="hasFinId(wallet_id)" class="w-full flex flex-column gap-2">
                    <div class="flex">
                        <ToggleButton v-model="addToAdeskWithdraw" class="w-24" onLabel="Добавить в Adesk ✅️️️️️️️" offLabel="Добавить в Adesk"  size="small"/>
                    </div>
                    <div v-if="addToAdeskWithdraw" class="w-full flex flex-column gap-2 mt-2">
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Статья:</span>
                            <Select v-model="selectedArticleWithdraw" :options="articleOptions(2)" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите статью" class="w-full border-2 border-round-lg" />
                        </div>
                        <div class="w-full flex flex-column gap-1">
                        <span class="flex text-600 mb-2 text-sm">Поставщик:</span>
                            <Select v-model="selectedContractorWithdraw" :options="contractorOptions" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите поставщика" class="w-full border-2 border-round-lg" />
                        </div>
                    </div>
                </div>

                <div class="w-full mb-3">
                    <span class="flex text-600 mb-2 text-sm">Описание:</span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                        :value="withdrawDescription"
                        @input="withdrawDescription = $event.target.value"
                        placeholder="Списание средств админом"
                        style="resize: none !important; font-family: inherit;"
                    />
                </div>
            </div>

            <template #footer>
                <Button label="Списать" @click='withdraw()' :disabled="withdrawDisabled" :loading="loading" class="bg-orange-500 border-orange-500 text-white"/>
            </template>
        </Dialog>

        <!--ПЕРЕВОД-->
        <Dialog header="Перевести" modal v-if="isUserInGroup('admin')" v-model:visible="displayTransfer" 
            class="flex flex-column border-none max-w-30rem" 
            :position="screenSize=='xs' ? 'bottom' : 'center'"
            :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
            :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'w-30rem'">


            <div class="w-full flex flex-column gap-3">
                <SelectButton v-model="toWalletSelected" :options="toWalletSelects" optionLabel="label" optionValue="value" aria-labelledby="multiple" class="flex" />

                <div class="w-full flex flex-column gap-2 px-2 py-3 surface-100 border-round-lg">
                
                    <!-- <div v-if="toWalletSelected=='system'" class="w-full flex flex-column gap-1">
                        <span class="flex text-600 text-sm">Со счета:</span>
                        <Select v-model="fromWalletId" :options="[]" optionLabel="name" optionValue="id" :disabled="true"
                            placeholder="Выберите счет" class="w-full border-2 border-round-xl">
                            <template #option="option">
                                <div class="flex flex-row text-sm gap-1 justify-content-between align-items-center">
                                    <span class="flex">{{ (option.option && option.option.name) ? option.option.name : '-' }}</span>
                                    <span class="text-xs text-500">{{ (option.option && option.option.type) ? option.option.type : '' }}</span>
                                    <span v-if="option.option.fin_id" class="text-xs text-white bg-blue-500 border-round-sm p-1">
                                        Adesk
                                    </span>
                                </div>
                            </template>
                        </Select>
                    </div> -->

                    <div v-if="toWalletSelected=='system'" class="w-full flex flex-column gap-1">
                        <span class="flex text-600 text-sm">На счет:</span>
                        <Select v-model="toWallet" :options="systemWallets" @update:modelValue="addToAdesk=false" filter optionLabel="description"
                            placeholder="Выберите кошелек" class="w-full border-2 border-round-xl">
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex flex-row text-sm gap-1 justify-content-start align-items-center">
                                    <span class="flex">{{ (slotProps.value && slotProps.value.name) ? slotProps.value.name : '-' }}</span>
                                    <Tag v-if="slotProps.value.ext_type" :value="GetWalletNameByLabel(slotProps.value.ext_type)" :class="getClassByLabel(slotProps.value.ext_type)" class="flex text-xs"/>
                                    <AvatarGroup v-if="slotProps.value.account_details && slotProps.value.account_details.length" 
                                        v-for="(acc, index) in slotProps.value.account_details" :key="index"
                                        class="gap-2">
                                            <Avatar v-if="acc.network" :image="GetNetworkImage(acc.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                            <Avatar v-else :image="GetCurrencyImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                    </AvatarGroup>
                                    <Tag v-if="slotProps.value.fin_id" value="Adesk" class="flex text-xs" severity="info"/>
                                </div>
                                <span v-else class="flex align-items-center h-full">
                                    <div class="text-sm">{{ slotProps.placeholder }}</div>
                                </span>
                            </template>
                            <template #option="option">
                                <div class="flex flex-row text-sm gap-1 justify-content-between align-items-center">
                                    <span class="flex">{{ (option.option && option.option.description) ? option.option.description : '-' }}</span>
                                    <Tag v-if="option.option.ext_type" :value="GetWalletNameByLabel(option.option.ext_type)" :class="getClassByLabel(option.option.ext_type)" class="flex text-xs"/>
                                    <AvatarGroup v-if="option.option.account_details && option.option.account_details.length" 
                                        v-for="(acc, index) in option.option.account_details" :key="index"
                                        class="gap-2">
                                            <Avatar v-if="acc.network" :image="GetNetworkImage(acc.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                            <Avatar v-else :image="GetCurrencyImage('usdt')" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                    </AvatarGroup>
                                    <Tag v-if="option.option.fin_id" value="Adesk" class="flex text-xs" severity="info"/>
                                </div>
                            </template>
                        </Select>

                        <Select v-if="toWallet && toWallet.account_details && toWallet.account_details.length" 
                            v-model="toAccount" :options="toWallet.account_details" 
                            placeholder="Выберите счет" class="w-full border-2 border-round-xl">
                             <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex flex-row text-sm gap-1 justify-content-start align-items-center">
                                    <AvatarGroup class="gap-2">
                                        <Avatar v-if="slotProps.value.network" :image="GetNetworkImage(slotProps.value.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                        <Avatar v-else-if="slotProps.value.currency" :image="GetCurrencyImage(slotProps.value.currency)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                    </AvatarGroup>
                                    <span class="flex">{{ GetCurrencyLabel(slotProps.value.currency) }}</span>
                                </div>
                                <span v-else class="flex align-items-center h-full">
                                    <div class="text-sm">{{ slotProps.placeholder }}</div>
                                </span>
                            </template>
                            <template #option="option">
                                <div class="flex flex-row text-sm gap-1 justify-content-between align-items-center">
                                    <AvatarGroup class="gap-2">
                                        <Avatar v-if="option.option.network" :image="GetNetworkImage(option.option.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                        <Avatar v-else-if="option.option.currency" :image="GetCurrencyImage(option.option.currency)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                    </AvatarGroup>
                                    <span class="flex">{{ GetCurrencyLabel(option.option.currency) }}</span>
                                </div>
                            </template>
                        </Select>
                        
                    </div>
                    <div v-else class="w-full flex flex-column gap-1">
                        <span class="flex text-600 text-sm">ID кошелька:</span>
                        <InputGroup class="flex">
                            <InputText v-model="toWalletIdText" placeholder="ID счета для зачисления"
                                class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                            <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                                <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="putTo()" />
                            </InputGroupAddon>
                        </InputGroup>
                        <InputGroup class="flex">
                            <InputText v-model="toCurrencyCode" placeholder="usdt"
                                class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        </InputGroup>
                    </div>
                    <span v-if="toWalletId" class="flex text-600 text-xs">WID: {{ toWalletId }}</span>
                    <span v-if="toAccountId" class="flex text-600 text-xs">AID: {{ toAccountId }}</span>
                    <span v-if="toCurrencyCode" class="flex text-600 text-xs">Currency: {{ toWalletCurrency || toCurrencyCode }}</span>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">
                        Сумма:
                    </span>
                    <InputGroup class="flex">
                        <InputNumber v-model="transferAmount" :min="0.0000000000001" :max="100000000" :maxFractionDigits="16" size="large"
                            class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                        <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                            <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                        </InputGroupAddon>
                    </InputGroup>
                    <div class="text-xs flex flex-1 flex-row justify-content-end"> 
                        <span class="text-blue-500 cursor-pointer" @click="setMaxAmount(max_amount)"> MAX </span>
                    </div>
                </div>

                <div v-if="hasFinId(wallet_id)" class="w-full flex flex-column gap-2">
                    <div class="flex">
                        <ToggleButton v-model="addToAdeskWithdraw" class="w-24" onLabel="Добавить в Adesk ✅️️️️️️️" offLabel="Добавить в Adesk"  size="small"/>
                    </div>
                    <div v-if="addToAdeskWithdraw" class="w-full flex flex-column gap-2 mt-2">
                        <div class="w-full flex flex-column gap-1">
                            <span class="flex text-600 mb-2 text-sm">Статья:</span>
                            <Select v-model="selectedArticleWithdraw" :options="articleOptions(2)" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите статью" class="w-full border-2 border-round-lg" />
                        </div>
                        <div class="w-full flex flex-column gap-1">
                        <span class="flex text-600 mb-2 text-sm">Поставщик:</span>
                            <Select v-model="selectedContractorWithdraw" :options="contractorOptions" optionLabel="label" optionValue="value" filter
                                placeholder="Выберите поставщика" class="w-full border-2 border-round-lg" />
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-column gap-1">
                    <span class="flex text-600 text-sm">
                        Описание:
                    </span>
                    <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                        :value="transferDescription"
                        @input="transferDescription = $event.target.value"
                        placeholder="Перевод между счетами админом"
                        style="resize: none !important; font-family: inherit;"
                        />
                </div>
            </div>

            <template #footer>
                <Button label="Перевести" @click='transfer()' :disabled="transferDisabled" :loading="loading" class="" severity="info"/>
            </template>
        </Dialog>
        
    </div>
    <Skeleton v-else height="1rem" class="border-round-lg"/>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: {
        wallet_id: {
            type: String,
            required: true,
        },
        currency_code: {
            type: String,
            required: true
        },
        max_amount: {
            type: String,
            default: '0'
        }
    },
    data() {
        return {
            loading: false,
            currencies: [],
            displayTopup: false,
            topupAmount: 0,
            topupDescription: '',
            displayWithdraw: false,
            withdrawAmount: 0,
            withdrawDescription: '',
            displayTransfer: false,
            transferAmount: 0,
            transferDescription: '',
            fromWalletId: this.wallet_id,
            toWallet: null,
            toAccount: null,
            toWalletIdText: '',
            // toWalletCurrency: null,
            toCurrencyCode: null,
            finData: {
                articles: [],
                contractors: [],
            },
            is_save: false,
            finDataLoading: false,
            fidDataLoaded: false,
            selectedArticle: null,
            selectedContractor: null,
            systemWallets: [],
            toWalletSelected: 'system',
            toWalletSelects: [
                {
                    value: 'system',
                    label: 'Системный',
                },
                {
                    value: 'user',
                    label: 'По ID',
                }
            ],
            addToAdesk: false,
            addToAdeskTopup: false,
            addToAdeskWithdraw: false,
            selectedArticleTopup: null,
            selectedContractorTopup: null,
            selectedArticleWithdraw: null,
            selectedContractorWithdraw: null,
        }
    },
    watch: {
        toWallet(newVal) {
            if (newVal && newVal.account_details && newVal.account_details.length) {
                this.toAccount = newVal.account_details[0];
            } else {
                this.toAccount = null;
            }
        },
        toWalletSelected(newVal) {
            this.resetTransferTarget(newVal)
        }
    },
    computed: {
        toWalletId() {
            if (this.toWalletSelected === 'system' && this.toWallet) {
                return this.toWallet.id || null;
            } else if (this.toWalletSelected === 'user') {
                return this.toWalletIdText;
            }
            return null;
        },
        toAccountId() {
            if (this.toWalletSelected === 'system' && this.toAccount) {
                return this.toAccount.id || null;
            }
            return null;
        },
        toWalletCurrency() {
            if (this.toWalletSelected === 'system' && this.toAccount) {
                return this.toAccount.currency || null;
            } else if (this.toWalletSelected === 'user' && this.toCurrencyCode) {
                return this.toCurrencyCode || null;
            }
            return null;
        },
        topupDisabled() {
            if (this.loading) return true
            if (!this.wallet_id) return true
            if (!this.topupAmount || isNaN(this.topupAmount) || this.topupAmount <= 0) return true
            if (this.hasFinId(this.wallet_id) && this.addToAdeskTopup && (!this.selectedArticleTopup || !this.selectedContractorTopup)) return true
            return false
        },
        withdrawDisabled() {
            if (this.loading) return true
            if (!this.wallet_id) return true
            if (!this.withdrawAmount || isNaN(this.withdrawAmount) || this.withdrawAmount <= 0) return true
            if (this.hasFinId(this.wallet_id) && this.addToAdeskWithdraw && (!this.selectedArticleWithdraw || !this.selectedContractorWithdraw)) return true
            return false
        },
        transferDisabled() {
            if (this.loading) return true
            if (!this.wallet_id || !this.toWalletId) return true
            if (!this.transferAmount || isNaN(this.transferAmount) || this.transferAmount <= 0) return true
            // if (this.hasFinId(this.wallet_id) && this.hasFinId(this.toWalletId) && this.addToAdesk && (!this.selectedArticle || !this.selectedContractor)) return true
            return false
        },
        screenSize() { return this.$store.getters.StateScreenSize },
        contractorOptions() {
            if (!this.finData || !Array.isArray(this.finData.contractors)) return []
            return this.finData.contractors.map(c => ({
                label: c.title || c.name || c.label || c.code || String(c.id || c._id || ''),
                value: c.id || c._id || c.code || c.value || null,
            })).filter(o => o.value !== null)
        },
    },
    methods: {
        resetTransferAdesk() {
            // Сбрасываем привязанные к переводу поля Adesk при смене способа перевода.
            this.addToAdesk = false
            this.selectedArticle = null
            this.selectedContractor = null
        },
        resetTransferTarget(mode = this.toWalletSelected) {
            this.resetTransferAdesk()

            if (mode === 'user') {
                // При переходе на ручной ввод очищаем выбор системного кошелька и счета.
                this.toWallet = null
                this.toAccount = null
                this.toCurrencyCode = null
                return
            }

            // При возврате к системному переводу очищаем введенные вручную ID и валюту.
            this.toWalletIdText = ''
            this.toCurrencyCode = null
        },
        setMaxAmount(amount) {
            if (!amount || isNaN(amount) || amount <= 0) return
            this.transferAmount = parseFloat(amount)
        },
        resetTransferForm() {
            // Единая точка сброса, чтобы диалог открытия и успешное завершение начинались с чистого состояния.
            this.transferAmount = 0
            this.transferDescription = ''
            this.resetTransferTarget(this.toWalletSelected)
        },
        articleOptions(type) {
            if (!this.finData || !Array.isArray(this.finData.articles)) return []
            return this.finData.articles.map(a => ({
                label: a.title || a.name || a.label || a.code || String(a.id || a._id || ''),
                value: a.id || a._id || a.code || a.value || null,
                type: a.type,
            })).filter(o => {
                return o.value !== null && o.type == type
            })
        },
        hasFinId(id) {
            // Проверка наличия fin_id в кошельке
            const wallets = this.systemWallets
            if (!wallets || !Array.isArray(wallets)) return false
            // if (!this.transferDescription || this.transferDescription.length <= 2) return false
            return !!wallets.find(w => w.id === id && w.fin_id)
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        openPopup(type) {
            if(!type) return
            if (!this.fidDataLoaded) {
                this.GetFinancial()
                this.GetSystemWallets()
                this.fidDataLoaded = true
            }
            if(type === 'transfer') this.resetTransferForm()
            if(type === 'topup') this.displayTopup = true
            if(type === 'withdraw') this.displayWithdraw = true
            if(type === 'transfer') this.displayTransfer = true
        },
        async getClipboardData() {
            try {
                const text = await navigator.clipboard.readText();
                return text;
            } catch (err) {
                console.error('Failed to read clipboard contents:', err);
                return null;
            }
        },
        put() {
            this.getClipboardData().then(data=>{
                if(data && !isNaN(data) && data>0) {
                    if(this.displayTopup) this.topupAmount = parseFloat(data)
                    if(this.displayWithdraw) this.withdrawAmount = parseFloat(data)
                    if(this.displayTransfer) this.transferAmount = parseFloat(data)
                }
            })
        },
        putTo() {
            this.getClipboardData().then(data=>{
                if(data) {
                    this.toWalletIdText = data.trim()
                }
            })
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        showMess(severity, summary, detail) {
            try{ this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 }) }
            catch(e) { console.log('error showMess', e) }
        },
        async topup(){
            this.loading = true
            try {
                const data = {
                    wallet_id: this.wallet_id,
                    amount: this.topupAmount,
                    currency_code: this.currency_code,
                    description: (this.topupDescription) ? this.topupDescription : 'Пополнение кошелька админом',
                    is_save: false,
                    options: {}
                }
                if (this.hasFinId(this.wallet_id) && this.addToAdeskTopup) {
                    data.is_save = true
                    data.options.categoryId = this.selectedArticleTopup
                    data.options.contractorId = this.selectedContractorTopup
                }
                const res = await this.connect.TopupWalletByAdmin(data)
                if(res && res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Пополнение прошло успешно', life: 2000 })
                    this.displayTopup = false
                    this.topupAmount = 0
                    this.addToAdeskTopup = false
                    this.selectedArticleTopup = null
                    this.selectedContractorTopup = null
                } else {
                    if(res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', (res.error) ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Topup error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async withdraw(){
            this.loading = true
            try {
                const data = {
                    wallet_id: this.wallet_id,
                    amount: this.withdrawAmount,
                    currency_code: this.currency_code,
                    description: (this.withdrawDescription) ? this.withdrawDescription : 'Списание средств админом',
                    is_save: false,
                    options: {}
                }
                if (this.hasFinId(this.wallet_id) && this.addToAdeskWithdraw) {
                    data.is_save = true
                    data.options.categoryId = this.selectedArticleWithdraw
                    data.options.contractorId = this.selectedContractorWithdraw
                }
                const res = await this.connect.WithdrawWalletByAdmin(data)
                if(res && res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Списание прошло успешно', life: 2000 })
                    this.displayWithdraw = false
                    this.withdrawAmount = 0
                    this.addToAdeskWithdraw = false
                    this.selectedArticleWithdraw = null
                    this.selectedContractorWithdraw = null
                } else {
                    if(res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', (res.error) ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Withdraw error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async transfer(){
            this.loading = true
            try {
                let data = {
                    from_wallet_id:     this.wallet_id,
                    to_wallet_id:       this.toWalletId,
                    amount:             this.transferAmount,
                    from_currency_code: this.currency_code,
                    to_currency_code:   this.toCurrencyCode || this.toWalletCurrency,
                    description:        (this.transferDescription) ? this.transferDescription : 'Перевод между счетами админом',
                    is_save:            false,
                    options: {
                        categoryId: null,
                        contractorId: null,
                    }
                }
                if (this.hasFinId(this.wallet_id) && this.addToAdeskWithdraw) {
                    data.is_save = true
                    data.options.categoryId = this.selectedArticleWithdraw
                    data.options.contractorId = this.selectedContractorWithdraw
                }
                // if (this.selectedArticle) data.options.article_id = this.selectedArticle
                // if (this.selectedContractor) data.options.contractor_id = this.selectedContractor
                const res = await this.connect.TransferWalletByAdmin(data)
                if(res && res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Перевод выполнен успешно', life: 2000 })
                    this.displayTransfer = false
                    this.resetTransferForm()
                } else {
                    if(res.message) this.showMess('warn', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', (res.error) ? res.error : 'Ошибка сервера')
                }
            } catch (e) {
                console.error('Transfer error', e)
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Сеть недоступна или внутренняя ошибка', life: 2000 })
            } finally {
                this.loading = false
            }
        },
        async GetFinancial(){
            this.finDataLoading = true
            try {
                this.connect.AdminGetFinancial().then(res=>{
                    if(res && res.result && res.data){
                        this.finData.articles = (res.data.articles) ? res.data.articles : []
                        this.finData.contractors = (res.data.contractors) ? res.data.contractors : []
                    }
                })
            } catch (e) {
                console.error('GetFinancial error', e)
            }
            this.finDataLoading = false
        },
        async GetSystemWallets(){
            this.systemWallets = (this.$store.getters.GetAdminWallets) ? this.$store.getters.GetAdminWallets : []
        },
        GetNetworkImage(val){
            return this.helper.GetNetworkImage(val)
        },
        GetCurrencyImage(val){
            if(!val || this.currencies.length === 0) return null
            return this.helper.GetCurrencyImage(val, this.currencies)
        },
        GetCurrencyLabel(val){
            return this.helper.GetCurrencyLabel(val)
        },
        getCurrencies(){
            const objList = (this.$store.getters.GetCurrencies) ? this.$store.getters.GetCurrencies : []
            if(!objList)return
            let currencies = []
            for(const [k,v] of Object.entries(objList)){
                currencies.push({
                    code: v.code,
                    name: k.toUpperCase(),
                    image: v.image
                })
            }
            this.currencies = currencies
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.fromWalletId = this.wallet_id
        this.getCurrencies()
    },
}
</script>